<script src="../../public/mms3D/js/mmsDT.project.js"></script>
<template>
    <div class="btn" :class="{ active: flag }" @click="changeShow($event)"></div>
</template>

<script>
    export default {
        name: "Btn",
      data(){
        return{
          flag:false
        }
      },
      methods:{
        changeShow(e){
          this.$emit('change');
          this.flag = !this.flag;
        }
      }
    }
</script>

<style scoped lang="less">
  .btn{
    cursor: pointer;
    background: url("./../assets/btn.png") no-repeat;
    background-size: 100% 100%;
    width: 27px;/*no*/
    height: 93px;/*no*/
    position: absolute;
    left:-27px;/*no*/
    top: 50%;
    transform: translateY(-50%);
    z-index: 9;
    &.active{
      background: url("./../assets/btn-fan.png") no-repeat;
      background-size: 100% 100%;
    }
  }
</style>
